const LOCAL_PUBLIC_WEB_ORIGIN = "http://127.0.0.1:4321";
const CADDY_PUBLIC_WEB_ORIGIN = "https://public.socialcoach.localhost";

// Caddy terminates TLS on :443. Astro is HTTP-only on :4321 and binds IPv4;
// Safari resolves localhost to ::1 first and the iframe fails to connect.
export const publicWebOrigin = (): string => {
  const { hostname } = window.location;
  if (hostname === "socialcoach.localhost") {
    return CADDY_PUBLIC_WEB_ORIGIN;
  }
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return LOCAL_PUBLIC_WEB_ORIGIN;
  }
  return window.location.origin;
};
